<template>
  <div
    class="grid grid-cols-1 gap-1 sm:grid-cols-3 sm:gap-x-4 sm:items-center mb-5"
  >
    <label :for="formFieldId" class="block text-sm font-medium text-gray-700">{{
      label
    }}</label>
    <TextInput
      :id="formFieldId"
      :name="formFieldId"
      v-model="value"
      :type="type"
      :placeholder="placeholder"
      :valid="!errorMessage"
      :disabled="disabled"
    ></TextInput>
    <div
      v-if="errorMessage"
      class="text-red-500 text-sm sm:col-start-2"
      data-testid="error-message"
    >
      {{ errorMessage }}
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "@vue/runtime-core";

import TextInput from "./TextInput.vue";
import { useField } from "vee-validate";
import { TextInputType } from "./TextInput.types";

export default defineComponent({
  props: {
    formFieldId: {
      type: String as PropType<string>,
      required: true,
    },
    type: {
      type: String as PropType<TextInputType>,
      default: TextInputType.TEXT,
    },
    label: String as PropType<string>,
    placeholder: String as PropType<string>,
    disabled: Boolean as PropType<boolean>,
  },
  components: {
    TextInput,
  },
  setup(props) {
    const { errorMessage, value } = useField<string | undefined>(
      props.formFieldId
    );
    return {
      errorMessage,
      value,
    };
  },
});
</script>
